// extracted by mini-css-extract-plugin
module.exports = {"tag":"_3xdra","new":"PRPAr","req":"_2gtwO","live":"Q3qYG"};